var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"clickable",on:{"click":function($event){return _vm.open(_vm.item)}}},[_c('div',{staticClass:"home-app"},[(_vm.hasIcon)?_c('i',{key:_vm.item.icon,class:'icon bi bi-' + _vm.item.icon}):_c('h3',[_vm._v(_vm._s(_vm.text))])]),_c('div',{staticClass:"name"},[_vm._v(_vm._s(_vm.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }